const INDEPENDENT_APPROVAL_PRODUCTS = new Set([
  "My Workspace",
  "Team Workspace",
  "Administration",
  "System Configuration",
]);

export const approvalRequiresEdit = (productName) =>
  !INDEPENDENT_APPROVAL_PRODUCTS.has(productName);

// editApplicable=false (the sub-module has no Edit action) keeps Approve from
// switching Edit on: Approve is offered on every sub-module (2026-10-01), so
// it can now be granted on rows where Edit does not apply.
export const updateRolePermission = (
  permissions,
  field,
  value,
  productName,
  editApplicable = true,
) => {
  const updated = { ...permissions, [field]: value };
  if (!approvalRequiresEdit(productName)) return updated;

  if (value && (field === "first_level_approver" || field === "second_level_approver")) {
    if (editApplicable) updated.editor = true;
  } else if (field === "editor" && !value) {
    updated.first_level_approver = false;
    updated.second_level_approver = false;
  }
  return updated;
};
